export default function InvalidWarning({ text }) {
  return <span className="small form-text text-danger">{text}</span>
}
